module.exports = __webpack_public_path__ + "static/img/login-img.4da9d580.png";